import * as React from "react";

export const TabSelector = ({
  isActive,
  children,
  onClick,
  goThroughTab = false,
  isMobile=false,
  shadeNav=false
}) => {
  return <>
    {
      isMobile ?
        <div
          className={`group inline-flex items-center w-full rounded-md border-4 leading-5 whitespace-nowrap ${
            isActive
              ? "border-primary focus:outline-none focus:text-primary focus:border-primary"
              : "border-gray-300"
          }
          ${goThroughTab ? "cursor-pointer" : "cursor-text"}
          ${shadeNav ? "border-primary":"border-gray-300"}
          `}
          onClick={onClick}
        >
      </div>
        :
        <button
          className={`mr-8 group inline-flex items-center px-2 py-4 border-b-4 font-semibold text-[0.8rem] sm:text-base md:text-md lg:text-md leading-5 whitespace-nowrap ${
            isActive
              ? "border-primary text-primary focus:outline-none focus:text-primary focus:border-primary"
              : "border-transparent text-gray-500 hover:text-gray-600 focus:text-gray-600"
          }
          ${goThroughTab ? "cursor-pointer" : "cursor-text"}
          `}
          onClick={onClick}
        >
          {children}
      </button>
    }
  </>
}